<template>
  <div class="maincontainer">
    <span>Empty.</span>
  </div>
</template>

<script>
export default {
  name: 'NetShop'
}
</script>

<style lang="scss" scoped>
.maincontainer {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
